import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { StyleService } from 'app/infrastructure/services/style.service';
import { EntityChildElement } from '../model/EntityChildElement';
import { EntityOperationModel } from '../model/EntityOperationModel';

@Component({
  selector: 'main-entity-component',
  templateUrl: './main-entity.component.html'
})
export class MainEntityComponent implements OnInit, OnDestroy {
  @Input('entityChildElement') entityChildElement: EntityChildElement;
  carouselElements: EntityOperationModel;
  @Input('carouselItemList') carouselItemList: EntityOperationModel;
  @Output() entitySetChild = new EventEmitter<EntityChildElement>();
  entityChilds: EntityChildElement[];

  constructor( private styleService: StyleService) { }

  ngOnInit() {
    this.styleService.addStyle('MainEntityComponent', require('./main-entity.component.css'));
  }

  ngOnDestroy() {
  }

  selectChild(child: EntityChildElement) {
    this.entitySetChild.emit(child);
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/entityWithChilds/main-entity-component/main-entity.component.ts